export const SHELF_PRODUCT_TEMPLATES_FILTERS_TEST_IDS = {
  PL_SELECT: 'shelf-product-templates-pl-select',
  EFFECTIVE_YEAR_SELECT: 'shelf-product-templates-effective-year-select',
};

export const SHELF_PRODUCT_TEMPLATES_TABLE_TEST_IDS = {
  TABLE: 'shelf-product-templates-table',
  TABLE_HEADER: 'shelf-product-templates-table-header',
};

export const SHELF_PRODUCT_TEMPLATES_ROW_TEST_IDS = {
  ROW: 'shelf-product-templates-row',
  DOWNLOAD_JSON_BTN: 'shelf-product-templates-row-download-json',
  UPLOAD_JSON_BTN: 'shelf-product-templates-row-upload-json',
  DELETE_JSON_BTN: 'shelf-product-templates-row-delete',
};

export const SHELF_PRODUCT_TEMPLATES_UPLOAD_JSON_MODAL_TEST_IDS = {
  MODAL: 'shelf-product-templates-upload-json-modal',
  FILE_UPLOAD: 'shelf-product-templates-upload-json-modal-file-upload',
};

export const SHELF_PRODUCT_TEMPLATES_DELETE_TEMPLATE_MODAL_TEST_IDS = {
  MODAL: 'shelf-product-templates-delete-json-modal',
};
